import { Grid, Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Fragment, useEffect, useLayoutEffect, useState, useMemo } from "react";
import LocalStorageService from "../../services/LocalStorageService";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import Swal from "sweetalert2";
import { getAllQuestions, getAllServices, getGeneralInformationsFromWordpress } from "../../api/ListOfServicesPerCategory";
import { getAllRepresentativeAndApplicant } from "../../api/myCompany";
import CenterLoading from "../../components/CenterLoading/CenterLoading";
import Collapsable from "../../components/Collapsable/Collapsable";
import LoginOrRegisterModal from "../../components/LoginOrRegisterModal/LoginOrRegisterModal";
import ServiceCatalogCard from "../../components/ServiceCatalogCard/ServiceCatalogCard";
import { ROLE_TYPE } from "../../constants/constants";
import { UpdateAppSubHeaderTitle } from "../../redux/actions/UiActions";
import { MediumHeightDivider, SmallHeightDivider } from "../../theme/Styles";
import { localDirections } from "./AllServicesConstants";
import DialogSelect from "./components/DialogSelect";
import { 
    Container, 
    BreadcrumbWrapper, 
    BreadcrumbInner, 
    BreadcrumbContent, 
    BreadcrumbLink, 
    BreadcrumbSeparator, 
    BreadcrumbCurrent,
    PageHeader,
    MainTitle,
    TabsContainer,
    TabItem,
    ContentInner,
    CategoryTitle
} from "./styles/AllServicesStyles";
import { generateSlug } from "../../utils/slugify";

function AllServices() {
    const matchesWidth = useMediaQuery("(min-width:768px)");
    const history = useHistory();
    const { search } = useLocation();
    const dispatch = useDispatch();
    const { authenticated, rolBase } = useSelector((state) => state.authReducer);
    const [open, setOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [service, setService] = useState("");

    const { data: allQuestionsData, isLoading: allQuestionsDataLoading } = useQuery(["allQuestionsData"], () => getAllQuestions());
    const { data: listOfServices, isLoading: listOfServicesLoading } = useQuery(["listOfServices"], () => getAllServices());
    const { data: allCompanyImIn, isLoading: allCompanyImInLoading } = useQuery(["allRepresentativeApplicantData"], () =>
        getAllRepresentativeAndApplicant()
    );

    const [loginOrRegisterModalStatus, setLoginOrRegisterModalStatus] = useState(false);
    
    // Active tab state
    const [activeCategoryId, setActiveCategoryId] = useState('all');

    const filteredCategories = useMemo(() => {
        if (!listOfServices) return [];
        if (activeCategoryId === 'all') return listOfServices;
        return listOfServices.filter(cat => cat.id === activeCategoryId);
    }, [listOfServices, activeCategoryId]);

    const handleOpenModal = (service) => {
        if (rolBase == ROLE_TYPE.COMPANY) {
            Swal.fire({
                title: "Información",
                text: "No puede realizar una solicitud directamente, debe ser a través de un representante",
                icon: "warning",
            });
            return;
        }
        if (authenticated) {
            if (companies?.length == 0) {
                history.push(`/solicitar-tramite/${generateSlug(service.name)}`);
                return;
            }
            setSelectedCompany(null);
            setService(service);
            setOpen(!open);
        } else {
            LocalStorageService.setItem("redirect_after_login", `/solicitar-tramite/${generateSlug(service.name)}`);
            setLoginOrRegisterModalStatus(!loginOrRegisterModalStatus);
        }
    };

    const handleServiceRequest = () => {
        if (!selectedCompany) {
            history.push(`/solicitar-tramite/${generateSlug(service.name)}`);
        } else {
            const [company_id, company_name] = selectedCompany?.split(",");
            history.push(`/solicitar-tramite/${generateSlug(service.name)}/${company_id}/${company_name}`);
        }
        setOpen(!open);
    };

    useLayoutEffect(() => {
        dispatch(UpdateAppSubHeaderTitle('')); // Hide the banner
    }, [dispatch]);

    useEffect(() => {
        document.body.style.backgroundColor = '#F8FAFC';
        return () => {
            document.body.style.backgroundColor = '';
        };
    }, []);

    useEffect(() => {
        if (allCompanyImIn?.payload) {
            const companies = allCompanyImIn.payload.map((x) => {
                return { company_name: x.company_name, id: x.id };
            });
            setCompanies(companies);
        }
    }, [allCompanyImIn]);

    useEffect(() => {
        if (!listOfServices) return;
        const params = new URLSearchParams(search);
        const catParam = params.get("categoria");
        if (catParam) {
            const rawParam = String(catParam).toLowerCase().trim();
            const cleanParam = rawParam.replace(/-/g, ' ');
            const targetSlug = generateSlug(rawParam);

            const found = listOfServices.find((cat) => {
                const catName = String(cat.name || "").toLowerCase();
                const catShortName = String(cat.short_name || "").toLowerCase();
                const nameSlug = generateSlug(cat.name || "");

                const idMatch = String(cat.id).toLowerCase() === rawParam;
                const slugMatch = nameSlug.includes(targetSlug) || targetSlug.includes(nameSlug);
                const textMatch = catName.includes(cleanParam) || cleanParam.includes(catName);
                
                // Specific keyword match for Licencias, Confotur, and DPP
                const isLicencia = (catName.includes('licencia') || catShortName.includes('licencia')) && 
                                   (cleanParam.includes('licencia') || cleanParam.includes('licencias'));
                const isConfotur = (catName.includes('confotur') || catShortName.includes('confotur')) && 
                                   cleanParam.includes('confotur');
                const isDPP = (catName.includes('dpp') || catName.includes('proyectos') || catShortName.includes('dpp')) && 
                              cleanParam.includes('dpp');

                return idMatch || slugMatch || textMatch || isLicencia || isConfotur || isDPP;
            });

            if (found) {
                setActiveCategoryId(found.id);
            }
        } else {
            setActiveCategoryId("all");
        }
    }, [search, listOfServices]);

    if (allQuestionsDataLoading || listOfServicesLoading || allCompanyImInLoading)
        return <CenterLoading />;

    return (
        <Container>
            <LoginOrRegisterModal
                open={loginOrRegisterModalStatus}
                onBackDropClick={() => setLoginOrRegisterModalStatus(false)}
                onCloseClick={() => setLoginOrRegisterModalStatus(false)}
            />
            
            <BreadcrumbWrapper>
                <BreadcrumbInner>
                    <BreadcrumbContent>
                        <BreadcrumbLink onClick={() => history.push('/')}>Inicio</BreadcrumbLink>
                        <BreadcrumbSeparator>/</BreadcrumbSeparator>
                        <BreadcrumbLink onClick={() => history.push('/todos-los-tramites')}>Trámites</BreadcrumbLink>
                        <BreadcrumbSeparator>/</BreadcrumbSeparator>
                        <BreadcrumbCurrent>Catálogo</BreadcrumbCurrent>
                    </BreadcrumbContent>
                </BreadcrumbInner>
            </BreadcrumbWrapper>

            <PageHeader>
                <MainTitle>Catálogo de Trámites</MainTitle>
                
                <TabsContainer>
                    <TabItem 
                        active={activeCategoryId === 'all'} 
                        onClick={() => setActiveCategoryId('all')}
                    >
                        Todos
                    </TabItem>
                    {listOfServices?.map((cat) => (
                        <TabItem 
                            key={cat.id} 
                            active={activeCategoryId === cat.id}
                            onClick={() => setActiveCategoryId(cat.id)}
                        >
                            {cat.short_name || cat.name}
                        </TabItem>
                    ))}
                </TabsContainer>
            </PageHeader>

            <ContentInner>
                {filteredCategories?.map((category) => (
                    <Box key={category.id} sx={{ mb: 12 }}> {/* Increased from 8 to 12 */}
                        <CategoryTitle>{category.name}</CategoryTitle>
                        <Grid container spacing={3}> {/* Slightly reduced card spacing to balance */}
                            {category.services?.map((service) => (
                                <Grid item xs={12} sm={6} md={4} key={service.id}>
                                    <ServiceCatalogCard 
                                        service={service}
                                        onViewDetails={() => history.push(`/tramite/${service.slug}`)}
                                        onApply={() => handleOpenModal(service)}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </ContentInner>

            <DialogSelect
                open={open}
                setOpen={setOpen}
                title="¿Cómo desea continuar?"
                setValue={setSelectedCompany}
                value={selectedCompany}
                data={companies}
                onClick={handleServiceRequest}
            />
        </Container>
    );
}

export default AllServices;
